<template>
    <div
      class="qc-tree-node"
      :class="{
        'is-leaf': node.isLeaf,
      }"
      @click.stop="nodeClick($event)"
      @contextmenu.stop="handleContextMenu($event)"
      ref="node"
    >
      <div
        class="qc-tree-node-content"
        :class="{
          'is-current': node.isCurrent,
          'is-contexting': node.isContexting,
        }"
      >
        <i v-if="node.loading" class="n-loading-icon"></i>
        <span v-else class="expand-icon-content">
          <i v-if="!node.isLeaf"
            :class="node.expanded ? 'icon-arrow-down' : 'icon-arrow-right'"></i>
          <i v-else class="icon-blank"></i>
        </span>
        <qc-checkbox
          v-if="showCheckbox"
          v-model="node.checked"
          :indeterminate="node.indeterminate"
          :on-value="true" :off-value="false"
          @input="handleCheckChange"
          @click.native.stop
        >
        </qc-checkbox>
        <node-content :node="node" v-if="tree.$scopedSlots.content"></node-content>
        <template v-else>
          <node-icon :node="node"></node-icon>
          <span class="qc-tree-node-label">{{ node.label }}</span>
        </template>
      </div>
      <div
        class="qc-tree-node-children"
        :class="'qc-tree-level-' + level"
        v-if="!node.isLeaf && node.expanded"
      >
        <qc-tree-node
          v-for="(item, index) in node.childNodes"
          :key="item.id"
          :node-index="index"
          :node-length="node.childNodes.length"
          :node="item"
          :level="level + 1"
          :render-content="renderContent"
          :lazy="lazy"
          :has-more="node.hasMore"
          :show-checkbox="showCheckbox"
        >
        </qc-tree-node>
      </div>
      <p class="qc-tree-node-load-more" :class="'load-more-level-'+level"
        v-if="hasMore && nodeIndex === nodeLength - 1" @click.stop="loadMore()">
        <i v-if="moreLoading" class="n-loading-icon"></i>加载更多
      </p>
    </div>
</template>

<script>
export default {
  name: 'qc-tree-node',
  props: {
    node: Object,
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 1,
    },
    renderContent: Function,
    lazy: {
      type: Boolean,
      default: false,
    },
    searchNodes: Function,
    hasMore: {
      type: Boolean,
      default: false,
    },
    nodeIndex: {
      type: Number,
      default: 0,
    },
    nodeLength: {
      type: Number,
      default: 0,
    },
  },
  components: {
    NodeIcon: {
      props: {
        node: {
          required: true,
        },
      },
      render(h) {
        const parent = this.$parent;
        const { tree, node } = parent;
        const { data } = this.node;
        if (parent.renderContent) {
          return parent.renderContent.call(parent._renderProxy, h, {
            _self: tree.$vnode.context, node, data,
          });
        }
        if (tree.$scopedSlots.icon) {
          return tree.$scopedSlots.icon({ node, data });
        }
        return ({});
      },
    },
    NodeContent: {
      props: {
        node: {
          required: true,
        },
      },
      render(h) {
        const parent = this.$parent;
        const { tree, node } = parent;
        const { data } = this.node;
        if (parent.renderContent) {
          return parent.renderContent.call(parent._renderProxy, h, {
            _self: tree.$vnode.context, node, data,
          });
        }
        if (tree.$scopedSlots.content) {
          return tree.$scopedSlots.content({ node, data });
        }
        return ({});
      },
    },
  },
  data() {
    return {
      tree: null,
      moreLoading: false,
    };
  },
  computed: {
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    'node.checked'(val) {
      this.handleSelectChange(val, this.node.indeterminate);
    },
    // eslint-disable-next-line object-shorthand
    'node.indeterminate'(val) {
      this.handleSelectChange(this.node.checked, val);
    },
  },
  methods: {

    setTree() {
      const parent = this.$parent;
      if (parent.isTree) {
        this.tree = parent;
      } else {
        this.tree = parent.tree;
      }
    },

    setContextingNode() {
      this.tree.store.setCurrentContextingNode(this.node);
    },

    nodeClick() {
      // console.log($event);
      this.tree.store.setCurrentNode(this.node);
      if (!this.node.isLeaf) {
        this.node.expanded = !this.node.expanded;
        this.handleExpand();
      }
      this.tree.$emit('node-click', this.node);
    },

    handleExpand() {
      if (this.node.expanded) {
        this.tree.$emit('node-expand', this.node);
      } else {
        this.tree.$emit('node-collapse', this.node);
      }
      // 异步加载子节点
      if (this.node.expanded && this.tree.lazy && !this.node.loaded) {
        this.loadNodes();
      }
    },

    handleContextMenu(event) {
      this.setContextingNode();
      this.tree.$emit('contextmenu', event, this.node, this.node.data);
    },

    handleSelectChange(checked, indeterminate) {
      this.tree.$emit('check-change', this.node, checked, indeterminate);
    },

    handleCheckChange(val) {
      this.node.setChecked(val);
    },

    // 异步加载子节点
    loadNodes() {
      const { node } = this;
      node.loading = true;
      node.store.load(node.data).then(res => {
        node.loading = false;
        node.loaded = true;
        node.hasMore = res.hasMore;
      });
    },

    // 异步加载同级更多节点
    loadMore() {
      const { node } = this;
      this.moreLoading = true;
      const { parent } = node;
      node.store.loadMore(parent.data).then(res => {
        this.moreLoading = false;
        parent.hasMore = res.hasMore;
      });
    },

    setChecked(val) {
      if (this.node.children && this.node.children.length > 0) {
        this.loopSetChecked(val);
      }
      // if (!this.parent.isTree) {

      // }
    },

    loopSetChecked(val) {
      const loop = list => {
        list.forEach(item => {
          item.checked = val;
          if (item.children && item.children.length > 0) {
            loop(item.children);
          }
        });
      };
      loop(this.node.children);
    },
  },
  created() {
    this.setTree();
    this.$watch('node.data.children', () => {
      this.node.updateChildren();
    });
  },
};
</script>

<style lang="scss" scoped>
.icon-blank {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.qc-tree-node-content {
  height: 26px;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #333;
  cursor: pointer;
  &>i {
    margin-right: 5px;
  }
  .form-ctrl-label {
    margin-right: 0;
  }
}
.qc-tree-node-content:hover {
  background: #e3e3e4;
}
.qc-tree-node-content.is-contexting {
  background: #ebecf1;
}
.qc-tree-node-content.is-current {
  background: #dee0e6;
  color: #111;
}
.qc-tree-node-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
@for $i from 0 to 20 {
  .qc-tree-level-#{$i}>.qc-tree-node>.qc-tree-node-content {
    padding-left: 15px * $i;
  }
  .load-more-level-#{$i} {
    padding-left: 15px * $i;
  }
}
.qc-tree-node-load-more {
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  color: #898c8e;
  cursor: pointer;
}
.qc-tree-node-load-more:hover {
  color: #111;
}
</style>
